import { useState, useEffect, useContext, useRef } from 'react';
import CompanyService from 'services/company2';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import Util from 'lib/util.js';
import * as React from 'react';
import Http from 'services/http2';
import { DETAIL_FIELD_CONFIG } from '../constants/bill-field-config.ts';
//单身自定义字段
import BodydCustField from 'components/bodyCustField';
import CustFieldService from 'services/custField';
import { ActionContext } from 'actions/context';
import './priceCompare.css';
function PriceCompare(props) {
  const {
    prodList,
    handleDrawer,
    decimalPlace,
    companyCode,
    workflow,
    isWfLineEdit,
    handleInput,
    doubleInquiryFlag,
    onFileListFetched
  } = props;
  const [companyParamObj, setCompanyParamObj] = useState({});
  const [lastPrcPriceShow, setLastPrcPriceShow] = useState(false);
  const [latestPurchasePriceShow, setLatestPurchasePriceShow] = useState(false);
  const [detailField, setDetailField] = useState([]);
  const { state, dispatch } = useContext(ActionContext);
  const [isEditField, setIsEditField] = useState(false); //采购方是否显示编辑按钮
  const [showLoading, setShowLoading] = useState(false);
  const [fieldSetting, setFieldSetting] = useState({
    headCustList: [],
    bodyCustList: []
  }); //自定义字段设置
  const [showWbs, setShowWbs] = useState(false);

  //根据依赖多次执行
  useEffect(() => {
    if (companyCode) {
      CompanyService.getCompanyParamsByCodes(
        companyCode,
        [
          'Quote_auto_transfer_base_currency_count',
          'price_order_compaeison_type',
          'Allow_selected_vendor_cycle_quote',
          'Inq_price_compare_by_cfg',
          'Is_Enable_Budget_Manage',
          'Allow_input_negotiate_price_cfg'
        ],
        false
      ).then(rs => {
        let o = {};
        rs.forEach(item => {
          o[item.paramCode] = item.paramValue;
          if (item.paramCode === 'price_order_compaeison_type') {
            setLastPrcPriceShow(o['price_order_compaeison_type'].includes('1'));
            setLatestPurchasePriceShow(
              o['price_order_compaeison_type'].includes('2')
            );
          }

          //WBS
          if (item.paramCode === 'Is_Enable_Budget_Manage') {
            if (o['Is_Enable_Budget_Manage'] === '1') {
              setShowWbs(item.paramFilter.includes(5));
            }
          }
        });
        if (rs.length > 0) {
          setCompanyParamObj(o);
        }
      });
    }

    //获取自定义字段设置
    async function getFieldSetting() {
      await CustFieldService.getSetting(
        companyCode,
        undefined,
        true,
        51,
        dispatch
      ).then(async setting => {
        if (setting) {
          //采购方是否显示编辑按钮
          setIsEditField(
            (setting?.headCustList?.length > 0 &&
              setting?.headCustList?.some(
                item => item['needVendorInputFlag'] === 0
              )) ||
              (setting?.bodyCustList?.length > 0 &&
                setting?.bodyCustList?.some(
                  item => item['needVendorInputFlag'] === 0
                ))
          );

          //上游单据字段转换
          await CustFieldService.transformSourceField(
            companyCode,
            companyCode,
            setting
          );

          //单头单身日期字段，转换为时间戳
          CustFieldService.parseCustFields(setting, {}, prodList, true);

          setting.bodyCustList = setting.bodyCustList?.filter(item =>
            item.fieldCode.includes('platform')
          );

          setFieldSetting(setting);
        }
      });
    }

    function userPreferenceDetail() {
      let postbody = {
        objCode: companyCode,
        objType: 2,
        contentType: '59',
        apiPath: '/userSetting/userPreferenceDetail'
      };
      Http.post('/api/cloudCenter', postbody).then(response => {
        if (response.success && response.data) {
          let res = Util.jsonDecode(response.data.contentJson) || {};
          if (res) {
            res.mobileDetailField = !Util.isEmpty(res.mobileDetailField)
              ? res.mobileDetailField
              : DETAIL_FIELD_CONFIG['59_mobile'];
            // 单据详情字段
            if (!Util.isEmpty(res.mobileDetailField)) {
              for (
                let i = 0;
                i < DETAIL_FIELD_CONFIG['59_mobile'].length;
                i++
              ) {
                let field = DETAIL_FIELD_CONFIG['59_mobile'][i];
                if (
                  res.mobileDetailField.some(
                    item => item.component === field.component
                  )
                ) {
                  field.hide =
                    res.mobileDetailField.filter(
                      item => item.component === field.component
                    )[0].hide || false;
                }
              }
              let mobileDetailField = DETAIL_FIELD_CONFIG['59_mobile']
                .filter(item => !item.hide)
                .map(item => item.component);
              setDetailField(mobileDetailField);
            }
          }
        }
      });
    }

    if (companyCode) {
      getFieldSetting();
      userPreferenceDetail();
    }
  }, [companyCode, prodList, dispatch]);

  //查看附件
  function showFileList(businessType, obj) {
    onFileListFetched(businessType, obj);
  }

  return (
    <div className="order-detail-list price-compare-list">
      <ul>
        {prodList &&
          prodList &&
          prodList.map((item, index) => (
            <li
              className={
                item.activeFlag
                  ? 'order-detail-item active'
                  : 'order-detail-item'
              }
              key={String(item.id) + index}
            >
              <div className="prod">
                {item.productCode}，{item.productName}，{item.productScale}
                <i
                  className="icon-down"
                  onClick={() => {
                    handleDrawer(item);
                  }}
                ></i>
              </div>
              {detailField.includes('extendFields') &&
                item.printExtendFields !== '' && (
                  <div>
                    <span className="field-label">采购说明：</span>
                    <div className="f-d-ib f-ml10">
                      {item.printExtendFields}
                    </div>
                  </div>
                )}
              {/* <div>

              </div> */}
              <div className="price">
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <span className="blue">
                          <b>
                            期望价格：
                            {formatNumber(
                              item.expectedPrice,
                              decimalPlace.Price_Decimal_Place
                            )}
                          </b>
                        </span>
                      </td>
                      <td>
                        <span className="green">
                          最低价：
                          {formatNumber(
                            item.minPrice,
                            decimalPlace.Price_Decimal_Place
                          )}
                        </span>
                      </td>
                      <td>
                        <span>
                          平均值：
                          {formatNumber(
                            item.avgPrice,
                            decimalPlace.Price_Decimal_Place
                          )}
                        </span>
                      </td>
                      <td>
                        <span className="red">
                          最高价：
                          {formatNumber(
                            item.maxPrice,
                            decimalPlace.Price_Decimal_Place
                          )}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      {companyParamObj['Allow_selected_vendor_cycle_quote'] ===
                        '1' && (
                        <td colSpan={2}>
                          <span className="blue">
                            下轮期望价格：
                            {!(
                              isWfLineEdit &&
                              workflow?.lineEditFields?.includes(
                                'nextExpectedPrice'
                              )
                            ) &&
                              formatNumber(
                                item.nextExpectedPrice,
                                decimalPlace.Price_Decimal_Place
                              )}
                            {isWfLineEdit &&
                              workflow?.lineEditFields?.includes(
                                'nextExpectedPrice'
                              ) && (
                                <input
                                  type="number"
                                  className="f-w100px"
                                  value={item.nextExpectedPrice || ''}
                                  onChange={e =>
                                    handleInput(e, item, 'nextExpectedPrice')
                                  }
                                />
                              )}
                          </span>
                        </td>
                      )}

                      <td colSpan={1}>
                        <span>
                          备注说明：
                          {!(
                            isWfLineEdit &&
                            workflow?.lineEditFields?.includes('remark')
                          ) &&
                            (item.remark || '--')}
                          {isWfLineEdit &&
                            workflow?.lineEditFields?.includes('remark') && (
                              <input
                                type="text"
                                className="f-w100px"
                                value={item.remark || ''}
                                onChange={e => handleInput(e, item, 'remark')}
                              />
                            )}
                        </span>
                      </td>
                      {item.isTransferedInq === 1 && (
                        <td colSpan={1}>
                          <span className="red">已转二次询价</span>
                        </td>
                      )}
                      {item.isTransferedInq === 2 && (
                        <td colSpan={1}>
                          <span className="red">已转二次竞价</span>
                        </td>
                      )}
                    </tr>
                  </tbody>
                </table>
              </div>
              {item.activeFlag && (
                <div className="quoProductsBox">
                  {item.detailList &&
                    item.detailList.map((line, idx) => (
                      <ul className="quoProductsList clearfix" key={idx}>
                        <li className="single">
                          <p className="f14">
                            {line.innerVendorName} {line.innerVendorCode}
                          </p>
                        </li>
                        {detailField.includes(
                          'quotePrice',
                          'thresholdEndQty'
                        ) && (
                          <li className="single">
                            {line.subList &&
                              line.subList.map((row, k) => (
                                <div className="quotes" key={k}>
                                  {detailField.includes('thresholdEndQty') && (
                                    <span>
                                      报价数量：
                                      {formatNumber(
                                        row.thresholdEndQty,
                                        decimalPlace.Quantity_Decimal_Place
                                      )}
                                    </span>
                                  )}
                                  {detailField.includes('quotePrice') && (
                                    <span>
                                      单价：
                                      {line.status !== 2 &&
                                        formatNumber(
                                          row.quotePrice,
                                          decimalPlace.Price_Decimal_Place
                                        )}
                                      {line.status === 2 && <span> *** </span>}
                                      {line.quoteCurrencyName || '--'}
                                      {companyParamObj.Inq_price_compare_by_cfg ===
                                        '1' &&
                                        row.unTaxPrice > item.avgPrice &&
                                        row.unTaxPrice && (
                                          <i className="icon-arrow-up red"></i>
                                        )}
                                      {companyParamObj.Inq_price_compare_by_cfg ===
                                        '1' &&
                                        row.unTaxPrice < item.avgPrice &&
                                        row.unTaxPrice && (
                                          <i className="icon-arrow-down green"></i>
                                        )}
                                      {companyParamObj.Inq_price_compare_by_cfg ===
                                        '2' &&
                                        row.taxPrice > item.avgPrice &&
                                        row.taxPrice && (
                                          <i className="icon-arrow-up red"></i>
                                        )}
                                      {companyParamObj.Inq_price_compare_by_cfg ===
                                        '2' &&
                                        row.taxPrice < item.avgPrice &&
                                        row.taxPrice && (
                                          <i className="icon-arrow-down green"></i>
                                        )}
                                    </span>
                                  )}
                                </div>
                              ))}
                          </li>
                        )}
                        {detailField.includes('thresholdEndQty') && (
                          <li>
                            报价单位：
                            {item.pricingUnitName}
                          </li>
                        )}
                        {detailField.includes('quoteAmountTotal') && (
                          <li>
                            报价金额：
                            {formatNumber(
                              line.quoteAmountTotal,
                              decimalPlace.Amount_Decimal_Place
                            )}
                            {line.quoteCurrencyName || '--'}
                          </li>
                        )}
                        {detailField.includes('priceContainTaxFlag') && (
                          <li>
                            含税否/税率：
                            {line.priceContainTaxFlagShow}
                            {line.taxRateShow ? line.taxRateShow + '%' : ''}
                          </li>
                        )}
                        {detailField.includes('unTaxPrice') &&
                          companyParamObj.Inq_price_compare_by_cfg === '1' && (
                            <li>
                              {line.subList &&
                                line.subList.map((row, k) => (
                                  <div className="quotes" key={k}>
                                    {
                                      <span>
                                        未税单价：
                                        {line.status !== 2 &&
                                          formatNumber(
                                            row.unTaxPrice,
                                            decimalPlace.Price_Decimal_Place
                                          )}
                                        {line.status === 2 && (
                                          <span> *** </span>
                                        )}
                                      </span>
                                    }
                                  </div>
                                ))}
                            </li>
                          )}
                        {detailField.includes('firstRoundPrice') &&
                          companyParamObj.Allow_selected_vendor_cycle_quote ===
                            '1' &&
                          doubleInquiryFlag === 1 && (
                            <li>
                              第一轮报价：
                              {formatNumber(
                                Util.isEmpty(line.firstNoBeChoosePrice)
                                  ? line.firstQuotePrice
                                  : line.firstNoBeChoosePrice,
                                decimalPlace.Price_Decimal_Place
                              )}
                            </li>
                          )}
                        {detailField.includes('firstQuotePriceInOneOrder') && (
                          <li>
                            初次报价：
                            {formatNumber(
                              line.firstQuotePriceInOneOrder,
                              decimalPlace.Price_Decimal_Place
                            )}
                          </li>
                        )}
                        {detailField.includes('promiseDeliDays') && (
                          <li>
                            承诺交期: {line.promiseDeliDays}
                            {line.promiseDeliDays ? '天' : ''}
                          </li>
                        )}
                        {detailField.includes('payMethodCode') && (
                          <li>付款方式：{line.payMethodName}</li>
                        )}
                        {detailField.includes('minPurchaseQty') && (
                          <li>最小采购量：{line.minPurchaseQty}</li>
                        )}
                        {detailField.includes('manufacturerProdCode') && (
                          <li>制造商料号：{line.manufacturerProdCode}</li>
                        )}
                        {detailField.includes('modelFee') && (
                          <li>模具费用：{line.modelFee}</li>
                        )}
                        {detailField.includes('brandName') && (
                          <li>品牌：{line.brandName}</li>
                        )}
                        {detailField.includes('minPackage') && (
                          <li>最小包装：{line.minPackage}</li>
                        )}
                        {detailField.includes('wbs') && showWbs && (
                          <li>
                            WBS：
                            {item.wbsCodeAliasDisplay
                              ? '(' + item.wbsCodeAliasDisplay + ')'
                              : ''}
                            {item.wbsName}
                          </li>
                        )}
                        {detailField.includes('wbsProject') && showWbs && (
                          <li>
                            请购项目：
                            {item.wbsProjectCode
                              ? '(' + item.wbsProjectCode + ')'
                              : ''}
                            {item.wbsProjectName}
                          </li>
                        )}

                        {(detailField.includes('prcDownPriceRate') ||
                          detailField.includes('lastPrcPrice') ||
                          detailField.includes('pricingTime')) &&
                          lastPrcPriceShow && (
                            <React.Fragment>
                              {detailField.includes('prcDownPriceRate') && (
                                <li>
                                  核价降价率：
                                  {line.prcDownPriceRate
                                    ? (line.prcDownPriceRate * 100).toFixed(2) +
                                      '%'
                                    : ''}
                                </li>
                              )}
                              {detailField.includes('lastPrcPrice') && (
                                <li>
                                  最新核价单价：
                                  {formatNumber(
                                    line.lastPrcPrice,
                                    decimalPlace.Price_Decimal_Place
                                  )}
                                </li>
                              )}
                              {detailField.includes('pricingTime') && (
                                <li>
                                  最近核价日期：
                                  {line.pricingTime
                                    ? formatDate(line.pricingTime, 'YYYY-MM-DD')
                                    : ''}
                                </li>
                              )}
                            </React.Fragment>
                          )}
                        {(detailField.includes('downPriceRate') ||
                          detailField.includes('latestPurchasePrice') ||
                          detailField.includes('latestPurchaseDate')) &&
                          latestPurchasePriceShow && (
                            <React.Fragment>
                              {detailField.includes('downPriceRate') && (
                                <li>
                                  采购降价率：
                                  {line.downPriceRate
                                    ? (line.downPriceRate * 100).toFixed(2) +
                                      '%'
                                    : ''}
                                </li>
                              )}
                              {detailField.includes('latestPurchasePrice') && (
                                <li>
                                  最新采购单价：
                                  {formatNumber(
                                    line.latestPurchasePrice,
                                    decimalPlace.Price_Decimal_Place
                                  )}
                                </li>
                              )}
                              {detailField.includes('latestPurchaseDate') && (
                                <li>
                                  最近采购日期：
                                  {line.latestPurchaseDate
                                    ? formatDate(
                                        line.latestPurchaseDate,
                                        'YYYY-MM-DD'
                                      )
                                    : ''}
                                </li>
                              )}
                            </React.Fragment>
                          )}
                        <li>
                          是否采用：
                          {[3, 1].includes(line.status) && (
                            <span className="red">{line.statusShow}</span>
                          )}
                          {line.status === 4 && (
                            <span className="green">{line.statusShow}</span>
                          )}
                        </li>
                        <li>中标类型：{line.selectedTypeShow}</li>

                        {companyParamObj['Allow_input_negotiate_price_cfg'] ===
                          '1' && (
                          <li>
                            议价单价：
                            {formatNumber(
                              line.negotiatePrice,
                              decimalPlace.PRICE
                            )}
                          </li>
                        )}
                        {companyParamObj['Allow_input_negotiate_price_cfg'] ===
                          '1' && (
                          <li>
                            议价金额：
                            {formatNumber(
                              line.negotiateAmount,
                              decimalPlace.Amount_Decimal_Place
                            )}
                          </li>
                        )}

                        {detailField.includes('description') && (
                          <li>报价说明：{line.description}</li>
                        )}
                        <li>比价说明：{line.priceCompareDesc}</li>
                        {detailField.includes('inquiryCompanyName') && (
                          <li>需求企业：{item.inquiryCompanyName}</li>
                        )}
                        {detailField.includes('offerValidityDateStart') && (
                          <li>
                            报价生效日期：
                            {line.offerValidityDateStart
                              ? formatDate(
                                  line.offerValidityDateStart,
                                  'YYYY-MM-DD'
                                )
                              : ''}
                          </li>
                        )}
                        {detailField.includes('offerValidityDate') && (
                          <li>
                            报价失效日期：
                            {line.offerValidityDate
                              ? formatDate(line.offerValidityDate, 'YYYY-MM-DD')
                              : ''}
                          </li>
                        )}
                        {Array.isArray(line.fileMd5s) &&
                          line.fileMd5s.length > 0 && (
                            <li>
                              图纸/文档：
                              <span
                                className="attachment"
                                onClick={() => showFileList(118, line)}
                              >
                                {line.fileMd5s.length}个附件
                                <i className="icon-attachment"></i>
                              </span>
                              {/* </div> */}
                            </li>
                          )}
                        {/* 单身自定义字段 */}
                        {detailField.includes('itemsCustomField') && (
                          <BodydCustField
                            fieldSetting={fieldSetting}
                            line={line}
                            isPurchase={true}
                          ></BodydCustField>
                        )}
                        {Array.isArray(line.pcLineFileMd5s) &&
                          line.pcLineFileMd5s.length > 0 && (
                            <li>
                              比价附件：
                              <span
                                className="attachment"
                                onClick={() => showFileList(110, line)}
                              >
                                {line.pcLineFileMd5s.length}个附件
                                <i className="icon-attachment"></i>
                              </span>
                              {/* </div> */}
                            </li>
                          )}
                      </ul>
                    ))}
                </div>
              )}
            </li>
          ))}
      </ul>
    </div>
  );
}
export default PriceCompare;
